'use client';

import { Button } from '@/components/ui/button';
import { AlertCircle, Download, Shield } from 'lucide-react';

export function APKDownload() {
  return (
    <section id="download" className="py-20 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="space-y-8">
          <div className="text-center space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold">
              Download <span className="text-primary">Yessma Originals</span>
            </h2>
            <p className="text-lg text-muted-foreground">
              Get the latest version and start streaming immediately
            </p>
          </div>

          {/* Download Card */}
          <div className="bg-card border border-border rounded-xl p-8 space-y-6">
            {/* Version Info */}
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Latest Version</span>
                <span className="text-primary font-semibold">3.2.1</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">File Size</span>
                <span className="text-foreground font-semibold">152 MB</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Android Version</span>
                <span className="text-foreground font-semibold">6.0+</span>
              </div>
            </div>

            {/* Download Button */}
            <Button size="lg" className="w-full bg-gradient-to-r from-primary to-pink-600 hover:from-pink-600 hover:to-primary text-white gap-2 h-12">
              <Download size={20} />
              Download APK Now
            </Button>

            {/* Safety Info */}
            <div className="bg-background/50 border border-border rounded-lg p-4 space-y-3">
              <div className="flex gap-3">
                <Shield size={20} className="text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-foreground">100% Safe & Secure</p>
                  <p className="text-sm text-muted-foreground">
                    Scanned by trusted antivirus software
                  </p>
                </div>
              </div>
            </div>

            {/* Requirements */}
            <div className="space-y-3">
              <h3 className="font-semibold text-foreground">Requirements:</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  Android 6.0 or higher
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  Minimum 200 MB free storage
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  Stable internet connection
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✓</span>
                  2GB RAM recommended
                </li>
              </ul>
            </div>
          </div>

          {/* Important Notice */}
          <div className="bg-background border border-border rounded-xl p-6 space-y-4">
            <div className="flex gap-3 items-start">
              <AlertCircle size={24} className="text-secondary flex-shrink-0 mt-0.5" />
              <div className="space-y-2">
                <h3 className="font-semibold text-foreground">Important Notice</h3>
                <p className="text-sm text-muted-foreground">
                  Yessma Originals may contain content that requires a subscription. Some features may vary by region. By downloading, you agree to our{' '}
                  <a href="/terms" className="text-primary hover:underline">
                    Terms & Conditions
                  </a>{' '}
                  and{' '}
                  <a href="/privacy" className="text-primary hover:underline">
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold">Common Questions</h3>
            <div className="grid gap-4">
              <div className="bg-card border border-border rounded-lg p-4">
                <h4 className="font-semibold text-foreground mb-2">Is it really free?</h4>
                <p className="text-sm text-muted-foreground">
                  Yes! Yessma Originals is free to download and use. Some premium features require an in-app subscription.
                </p>
              </div>
              <div className="bg-card border border-border rounded-lg p-4">
                <h4 className="font-semibold text-foreground mb-2">Is my data safe?</h4>
                <p className="text-sm text-muted-foreground">
                  We use industry-standard encryption to protect your data. Read our Privacy Policy for more details.
                </p>
              </div>
              <div className="bg-card border border-border rounded-lg p-4">
                <h4 className="font-semibold text-foreground mb-2">Can I watch offline?</h4>
                <p className="text-sm text-muted-foreground">
                  Yes! Download your favorite content and watch anytime, even without internet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
